import { forwardRef, type SVGProps } from "react";
// eslint-disable-next-line react/display-name
const SvgStatusSaving = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <path
        id="Saving In Progress"
        d="M15.0201 7.5C15.0201 3.36 11.6601 0 7.52014 0C3.38014 0 0.0201416 3.36 0.0201416 7.5C0.0201416 11.64 3.38014 15 7.52014 15C11.6601 15 15.0201 11.64 15.0201 7.5ZM9.77014 3.375L12.3951 6L9.77014 8.625V6.75H6.77014V5.25H9.77014V3.375ZM5.27014 11.625L2.64514 9L5.27014 6.375V8.25H8.27014V9.75H5.27014V11.625Z"
        fill="#FF8600"
      />
    </g>
  </svg>
));
export default SvgStatusSaving;
